module.exports = __webpack_public_path__ + "static/media/close.da014afb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/close.svg
// module id = 485
// module chunks = 7